import React, { useState } from "react";
import ReportTable from "../subComponents/reportTable";
import ReportFilters from "../subComponents/reportFilter";
import { columnsConfig } from "../reportColumns";

const PendingChequeReport: React.FC = () => {
  const [filterInputs, setFilterInputs] = useState({
    fromDate: "",
    toDate: ""
  });

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: ""
  });

  const handleApplyFilters = () => {
    setFilters(filterInputs);
  };

  const handleResetFilters = () => {
    const empty = { fromDate: "", toDate: "" };
    setFilterInputs(empty);
    setFilters(empty);
  };

  return (
    <div>
      <ReportFilters
        filters={filterInputs}
        setFilters={setFilterInputs}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
      />
      <ReportTable
        title="Pending Cheque Report"
        endpoint="chequereports/reports/pending"
        columns={columnsConfig.pendingChequeColumns}
        filters={filters}
      />
    </div>
  );
};

export default PendingChequeReport;